import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getOrderCancelReason } from "../../redux/actions/action-creator";
import "./CancelModal.css";

const getResponseList = (response) => {
  const data = response?.data;

  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.cell_contents)) return data.cell_contents;
  if (Array.isArray(data?.response_data)) return data.response_data;
  if (Array.isArray(data?.cancel_reasons)) return data.cancel_reasons;
  if (Array.isArray(data?.cancel_reason)) return data.cancel_reason;
  if (Array.isArray(data?.reasons)) return data.reasons;
  if (Array.isArray(data?.reason_list)) return data.reason_list;
  if (Array.isArray(response?.cell_contents)) return response.cell_contents;
  if (Array.isArray(response?.response_data)) return response.response_data;
  if (Array.isArray(response?.cancel_reasons)) return response.cancel_reasons;
  if (Array.isArray(response?.cancel_reason)) return response.cancel_reason;
  if (Array.isArray(response?.reasons)) return response.reasons;
  if (Array.isArray(response?.reason_list)) return response.reason_list;

  return [];
};

const getReasonId = (reason) =>
  reason?.id ??
  reason?.reason_id ??
  reason?.cancel_reason_id ??
  reason?.value ??
  "";

const getReasonLabel = (reason) =>
  reason?.reason ||
  reason?.cancel_reason ||
  reason?.cancel_reason_text ||
  reason?.title ||
  reason?.name ||
  reason?.label ||
  reason?.value ||
  "Cancel reason";

const CancelReasonModal = ({ show, onClose, onSubmit, orderId, segmentId, submitting = false }) => {
  const dispatch = useDispatch();
  const [selected, setSelected] = useState("");
  const [reasons, setReasons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) {
      setSelected("");
      setReasons([]);
      setError("");
      setLoading(false);
      return;
    }

    const loadCancelReasons = async () => {
      if (!orderId || !segmentId) {
        setError("Order or segment detail not found.");
        return;
      }

      setLoading(true);
      setError("");

      const payload = new URLSearchParams();
      payload.append("order_id", orderId);
      payload.append("segment_id", segmentId);

      try {
        const response = await dispatch(getOrderCancelReason(payload));
        setReasons(getResponseList(response));
      } catch (apiError) {
        setReasons([]);
        setError(
          apiError?.response?.data?.message ||
          apiError?.message ||
          "Unable to load cancel reasons."
        );
      } finally {
        setLoading(false);
      }
    };

    loadCancelReasons();
  }, [dispatch, orderId, segmentId, show]);

  if (!show) return null;

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-box">

        {/* Header */}
        <div className="review-popup-header">
          <h2 className="review-popup-title">Select Reason</h2>
          <button className="review-popup-close" onClick={onClose}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-body">
          {loading && <div className="cancel-reason-message">Loading reasons...</div>}
          {error && <div className="cancel-reason-error">{error}</div>}
          {!loading && !error && !reasons.length && (
            <div className="cancel-reason-message">No cancel reasons found.</div>
          )}

          {reasons.map((reason) => {
            const reasonId = String(getReasonId(reason));

            return (
              <label className="radio-row" key={reasonId}>
                <span>{getReasonLabel(reason)}</span>
                <input
                  type="radio"
                  name="cancelReason"
                  checked={selected === reasonId}
                  onChange={() => setSelected(reasonId)}
                />
              </label>
            );
          })}
        </div>

        <button
          className="submit-btn-full"
          disabled={!selected || loading || submitting}
          onClick={() => onSubmit(selected)}
        >
          {submitting ? "Cancelling..." : "Submit"}
        </button>
      </div>
    </div>
  );
};

export default CancelReasonModal;
